const ContactMap = ({ data }) => {
  const mapHTML = data?.AppSetting?.ifameMap || "";

  const updatedHTML = mapHTML.includes("title=")
    ? mapHTML
    : mapHTML.replace("<iframe", "<iframe title='Map'");

  return (
    <div
      dangerouslySetInnerHTML={{
        __html: updatedHTML,
      }}
    />
  );
};

export default ContactMap;
